const Nav = navigator || window.navigator
export const ua = Nav.userAgent || Nav.userAgent
const PORTRAIT = 'portrait' // 竖向
const LANDSCAPE = 'landscape' // 横向

const browser = {
    isMobile: !!ua.match(/Mobile.*/),
    isAndroid: ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1,
    isiOS: /(iPhone|iPad|iPod|iOS)/i.test(ua),
    isiPad: /(iPad)/i.test(ua),
    get orientation() {
        if (window.orientation !== undefined) {
            if (Math.abs(window.orientation) === 90) {
                return LANDSCAPE
            } else {
                return PORTRAIT
            }
        } else {
            let cw = document.documentElement.clientWidth
            let sw = window.screen.width
            let sh = window.screen.height
            let _width = sw < sh ? sw : sh
            let _height = sw >= sh ? sw : sh
            if (cw === _width) {
                return PORTRAIT
            }
            if (cw === _height) {
                return LANDSCAPE
            }
            return PORTRAIT
        }
    },
    isWebApp: Nav.standalone,
    inWxEnv: typeof WeixinJSBridge !== 'undefined' || ua.toLowerCase().indexOf('micromessenger') !== -1 || /micromessenger/i.test(ua.toLowerCase()),
    isSafari: /Safari/.test(ua) && !/Chrome/.test(ua),
    isPC: !(/mobile|android|iphone|ipad/.test(ua.toLowerCase()) || (navigator?.platform === 'MacIntel' && navigator?.maxTouchPoints > 1)),
}
/** 判断是否为刘海屏的iPhone
 * iphoneX及之后更新的iphone手机，其window.screen.height最小是812，且window.devicePixelRatio最小是2。
 * @author Carson @date 2020/11/5
 * */
browser.isNewIPhone = browser.isiOS && window.screen.height >= 812 &&
    window.devicePixelRatio >= 2

browser.isMobile = browser.isMobile || browser.isAndroid || browser.isiOS

export const platform = browser.isiOS ? 2 : browser.isAndroid ? 1 : 3

export function resetFontSize() {
    let deviceWidth = 480
    const windowWidth = document.body.clientWidth || window.innerWidth ||
        window.screen.availWidth || window.screen.width
    if (browser.isMobile) {
        deviceWidth = windowWidth
    } else {
        deviceWidth = deviceWidth < windowWidth ? deviceWidth : windowWidth
    }
    document.body.style.fontSize = 16 * deviceWidth / 375 + 'px'

}

export default browser
